export default "__VITE_ASSET__8cf12f02__"